import { ICardElementWithChildren } from "backend/model/model";
import { usePeriod } from "backend/model/usePeriod";
import getValues from "backend/values";
import { useQuery } from "react-query";
import useModel from "../model/useModel";
import usePeriodLevels from "../model/usePeriodLevels";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import * as wf from "@qpr/client-api-workflow";
import usePeriods from "../model/usePeriods";

export type TWorkflowInstance = {
  wfInstanceId: string;
  type: string;
  currentState: string;
  message: string;
  nextTransitions: string[];
  allowedActions: string[];
  meaId: string;
  period: string;
  series: string;
  latestLog?: any;
};

export type TWorkflowQueryParameter = {
  series: string;
  period: string;
  type: string;
};

const useMyWorkflows = <
  T extends { id: string; workflow?: TWorkflowInstance | undefined }[]
>() => {
  const ctx = useAppContext();
  const periods = usePeriods();
  const { data: periodLevels } = usePeriodLevels();
  const { data: model } = useModel();

  return useQuery(
    `data-myworkflows-${ctx.period}`,
    () => {
      return wf
        .queryMyWorkflows({
          type: "value",
          attributes: "name",
          modelId: model?.[0].id || "",
          values: [],
        })
        .then((taskData) => {
          console.log("MyWorkflows taskData", taskData);
          return Promise.all(
            taskData!.map((task) => {
              return getValues(
                task.id,
                periods!.data!.filter((n) => n.name === task.workflow?.period),
                true,
                periodLevels!
              ).then((list) => {
                console.log("", task, list);
                return {
                  ...list[0],
                  workflowInstance: task.workflow,
                } as ICardElementWithChildren;
              });
            })
          );
        });
    },
    {
      keepPreviousData: false,
      enabled:
        !periods.isLoading && !!periodLevels && !!model && !!model?.[0].id,
    }
  );
};

export default useMyWorkflows;
